import Payment from './Payment.vue';
import Socials from './Socials.vue';
export default {
  name: 'PaymentSocials',
  components: {
    Payment,
    Socials
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};